<div class='chatContainer' [class.chatContainerOpen]='this.isOpen'>
  <div class='chatHeader'>
    <span class='chatHeaderLabel'><i class="fas fa-comments"></i> Timeline Chat</span>
    <button class='chatCloseButton' (click)='this.close()'><i class="fas fa-times"></i></button>
  </div>

  <div class='chatMessageList' #messageList>
    @if (this.messages.length === 0) {
      <div class='chatEmptyState'>No messages yet - say hello.</div>
    }

    @for (message of this.messages; track message.id) {
      <div class='chatMessageRow' [class.chatMessageRowOwn]='this.isOwnMessage(message)'>
        <img class='chatAvatar' [src]='this.getAvatarUrl(message)' [attr.title]='message.firstName + " " + message.lastName' />
        <div class='chatBubble'>
          <div class='chatBubbleMeta'>
            <span class='chatBubbleName'>{{ message.firstName }} {{ message.lastName }}</span>
            <span class='chatBubbleTime'>{{ message.timestamp | date:'HH:mm' }}</span>
          </div>
          <div class='chatBubbleText'>{{ message.text }}</div>
        </div>
      </div>
    }
  </div>

  <div class='chatInputRow'>
    <input
      type='text'
      class='form-control'
      placeholder='Type a message...'
      [(ngModel)]='this.newMessageText'
      (keydown.enter)='this.sendMessage()'
      />
    <button class='btn btn-primary' (click)='this.sendMessage()'><i class="fas fa-paper-plane"></i></button>
  </div>
</div>
